import aiCall from './ai_call/AiCall';
import eventList from './event_list/eventList';
import error from './error';
import auth from './auth/auth';
import navbar from './navbar/navbar';
import correspondances from './miscellaneous/correspondances';
import generic from './miscellaneous/generic';
import timeFormat from './miscellaneous/timeFormat';
import table from './miscellaneous/table';
import dashboard from './dashboard/dashboard';
import dashboardWidgets from './dashboard/dashboardWidgets';
import profile from './profile/profile';
import redirect from './redirect';
import caregiverScreening from './caregiver_screening/caregiverScreening';
import caregiverInterview from './caregiver_interview/caregiverInterview';
import caregiverProfile from './caregiver_profile/caregiverProfile';

export default {
  aiCall,
  eventList,
  error,
  auth,
  navbar,
  correspondances,
  generic,
  timeFormat,
  table,
  dashboard,
  dashboardWidgets,
  profile,
  redirect,
  caregiverScreening,
  caregiverInterview,
  caregiverProfile,
};
